import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export default function GuestOnly({ children }) {
  const { user } = useContext(AuthContext) || { user: null };
  if (user) return <Navigate to="/" replace />;
  return children;
}